export const gruposEndpoint = {
    // Grupos
    listar: `/api/v1/grupos`,
    listarSimple: `/api/v1/grupos/simple`,
    criar: `/api/v1/grupos`,
    atualizar: (id) => `/api/v1/grupos/${id}`,
    apagar: (id) => `/api/v1/grupos/${id}`,
    
    // Pessoas
    listarPessoasFisicas: (grupo) => `/api/v1/grupos/${grupo}/pessoas-fisicas`,
}
